"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ProductListingState {
  categoryIdFromStore: number;
  subCategoryIdFromStore: number;
  setCategoryIdToStore: (id: number) => void;
  setSubCategoryIdToStore: (id: number) => void;
  clearCategoryIdFromStore: () => void;
  clearSubCategoryIdFromStore: () => void;
}

export const useProductListingStore = create<ProductListingState>()(
  persist(
    (set) => ({
      categoryIdFromStore: 1525,
      subCategoryIdFromStore: 0,

      setCategoryIdToStore: (id) => set({ categoryIdFromStore: id }),
      setSubCategoryIdToStore: (id) => set({ subCategoryIdFromStore: id }),

      clearCategoryIdFromStore: () => set({ categoryIdFromStore: 0 }),
      clearSubCategoryIdFromStore: () => set({ subCategoryIdFromStore: 0 }),
    }),
    {
      name: "product-listing-store",
    }
  )
);
